import type React from 'react';
import { useParams } from 'react-router-dom';
import {
    CatalogImportLeaveGuard,
    CatalogImportProvider,
} from '@/pages/catalogImport/store';
import { PATH } from '@/router/PATH';
import { BranchImportPageContent } from './BranchImportPageContent';

/**
 * `/branches/:branchId/import/*` — one branch's catalog import after
 * onboarding, inside the shell, with the navbar's back button to Branches
 * (`navigation.ts`). The wizard's File, Names, Products and Result steps run
 * here as route segments (`PATH.BRANCHES.IMPORT_STEP`) with the branch
 * fixed; there is no Branch step and no Undo.
 *
 * The page mounts its own import store, keyed by the branch so another
 * branch's address starts a fresh import, and the leave guard asks before a
 * navigation out of this branch's import would lose a parsed file.
 */
export const BranchImportPage: React.FC = () => {
    const branchId = useParams().branchId ?? '';

    return (
        <CatalogImportProvider key={branchId}>
            <CatalogImportLeaveGuard
                mode="shell"
                scopePath={PATH.BRANCHES.BIND_IMPORT(branchId)}
            />
            <BranchImportPageContent branchId={branchId} />
        </CatalogImportProvider>
    );
};
